export default __webpack_public_path__ + "static/media/0x5e430f88d1be82eb3ef92b6ff06125168fd5dcf2.4ae9dde1.webp";